import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src760788307/src/mds-docs/gatsby-theme-mds/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Preview = makeShortcode("Preview");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h4 {...{
      "id": "types"
    }}>{`Types`}</h4>
    <br />
    <h5 {...{
      "id": "basic"
    }}>{`Basic`}</h5>
    <p>{`Basic button is used the most across products. It provides a lightweight button style while still maintaining affordability.`}</p>
    <Preview name='basic-button' mdxType="Preview" />
    <h5 {...{
      "id": "primary"
    }}>{`Primary`}</h5>
    <p>{`Primary button highlights the primary action on a page. Preferably have only one primary action per page. If you think more than one primary action is needed, try to re-evaluate the priority of actions.`}</p>
    <Preview name='primary-button' mdxType="Preview" />
    <h5 {...{
      "id": "alert"
    }}>{`Alert`}</h5>
    <p>{`Alert button indicates destructive actions on a page, in dialogs, or in settings.`}</p>
    <Preview name='alert-button' mdxType="Preview" />
    <h5 {...{
      "id": "transparent"
    }}>{`Transparent`}</h5>
    <p>{`Transparent button indicates actions that are less important or less frequent.`}</p>
    <Preview name='transparent-button' mdxType="Preview" />
    <h5 {...{
      "id": "expanded"
    }}>{`Expanded`}</h5>
    <p>{`Expanded button is used when the width of the button needs to match the parent. Use it sparingly as it takes a lot of space and attention.`}</p>
    <Preview name='expanded-button' mdxType="Preview" />
    <h5 {...{
      "id": "icon-with-label"
    }}>{`Icon with Label`}</h5>
    <p>{`Icon with label adds additional visual cues in buttons. The icon can either precede the label or succeed it.`}</p>
    <Preview name='icon-left-button' mdxType="Preview" />
    <h5 {...{
      "id": "icon-in-right"
    }}>{`Icon in Right`}</h5>
    <br />
    <Preview name='icon-right-button' mdxType="Preview" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      